// material-ui
import logo from '../../pages-new/auth/auth1/Image/apexlogo.svg';//'../../pages/auth/auth1/Image/apexlogo.svg';
export default function LogoMain() {
  return (
    <>
      <img src={logo} alt="logo" width="85%" />
    </>
  );
}
